import "./tab-filter-v2.scss";
import { useId } from "react";
import {
  addPhraseToSelection,
  bulkSaveFilterChoices,
  clearAllSelections,
  clearSelectedFields,
  getExactPhrases,
  getHistoryForField,
  initializeFilterChoicesv2,
  selectFilterErrorMessage,
  selectSelectedFieldsAarray,
  selectSelectedFilterChoices,
  selectSelectedTabFilterInfo,
  setFilterChoiceToBeEdited,
  setFilterDialogState,
  setFilterErrorMessage,
  setHistoryListForActiveFieldr,
  setSelectedAllFieldsArray,
  setSelectedTabFilterInfo,
  setUnSelectedAllFieldsArray,
  toggleCheckForField,
} from "../../../../redux/reducers/tabFilterSlice";
import { TAB_FILTER_HEADERS } from "../../../../common/constants";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { useEffect, useState } from "react";
import { selectClients } from "../../../../redux/reducers/metadataSlice";
import { selectUserID } from "../../../../redux/reducers/userSlice";
import { fetchUserClientsDocuments } from "../../../../redux/reducers/documentsDataSlice";
import { FilterFieldChoiceEntity } from "../../../../common/types/EntityTypes";
import cross from "../../../../assets/images/dashboard/tab/cross_svg.svg";
import customInputcross from "../../../../assets/images/dialog/filter/filter_V2/cross.svg";
import tick from "../../../../assets/images/dialog/filter/filter_V2/tick.svg";
import duplicate from "../../../../assets/images/dialog/filter/Duplicate_White.svg";
import edit from "../../../../assets/images/dialog/filter/Edit_White.svg";
import trashbin from "../../../../assets/images/dialog/filter/trashIcon_White.svg";
import states from "../../../dialog/edit/editable-value/states-constants";
import { sortFilterChoicesv2 } from "../../../../redux/reducers/tabFilterSlice";

function TabFilter() {
  const dispatch = useAppDispatch();
  const baseId = useId()
  const selectedTabFilter = useAppSelector(selectSelectedTabFilterInfo);
  const selectedFilterChoices = useAppSelector(selectSelectedFilterChoices);
  const errorMessage = useAppSelector(selectFilterErrorMessage);
  const selectedFieldsArray = useAppSelector(selectSelectedFieldsAarray);
  const tabFilterFieldList = TAB_FILTER_HEADERS;
  const tabFilterName = selectedTabFilter?.name;
  const [activeFieldCode, setActiveFieldCode] = useState("001a");
  const [phrasesFromDb, setPhrasesfromDb] = useState<any>(false);
  const [changesMade, setChangesMade] = useState(false);
  const [isSettingsSaved, setIsSettingsSaved] = useState(false);
  const [changesApplied, setChangesApplied] = useState(false);
  const [phrase, setNewPhrase] = useState("");
  const [showEditInput, setShowEditInput] = useState(false);
  const [indexOfCurrentItem, setCurrentItemIndex] = useState(0);
  const [editedField, setEditedField] = useState("");
  const [allSelectedHistory, setSelectAllHistory] = useState<string[]>([]);
  const [sortType, setSortType] = useState("alphabetic");
  const [reRun,setRerun] = useState(false);
  const userId = useAppSelector(selectUserID);
  const clients = useAppSelector(selectClients);

  useEffect(() => {
    if (selectedTabFilter?.name) {
      dispatch(initializeFilterChoicesv2({}));
    }
  }, [selectedTabFilter]);

  useEffect(() => {
    dispatch(getExactPhrases({ filterId: selectedTabFilter?.id })).then(
      (res) => {
        let presSelectedPhrases = res.payload.data;
        //the block below converts State' names to the format of UI, not a clean fix alternate method needs to be found
        let modifiedSelectedPhrase = Object.values(presSelectedPhrases).map(
          ([eachFieldCodePhrase]: any) => {
            if (eachFieldCodePhrase.fieldCode !== "003m")
              return eachFieldCodePhrase;
            let newStateFieldPhrases = { ...eachFieldCodePhrase };
            newStateFieldPhrases.has = newStateFieldPhrases?.has?.map(
              (element: any) => {
                let newName = states.find(
                  (eachState) =>
                    element?.text === eachState.abbr ||
                    element?.text === eachState.name
                );
                return {
                  ...element,
                  text: `${newName?.name} (${newName?.abbr})`,
                };
              }
            );
            return newStateFieldPhrases;
          }
        );
        presSelectedPhrases = modifiedSelectedPhrase?.reduce((acc, each) => {
          acc[each.fieldCode] = [each];
          return acc;
        }, {});
        setPhrasesfromDb(presSelectedPhrases);
      }
    );
  }, [selectedTabFilter, changesApplied]);

  useEffect(() => {
    if (phrasesFromDb) {
      tabFilterFieldList.map(({ fieldCode }) => {
        dispatch(getHistoryForField(fieldCode)).then((res) => {
          // let historyPhrasesForSelectedField = res?.payload?.data.sort();
          // let historyPhrasesForSelectedField = res?.payload?.data;
          // Removing Duplicates
          let historyPhrasesForSelectedField = res?.payload?.data
            .filter((each: any) => each.value !== "")
            .filter(
              (item: any, index: number, self: any[]) =>
                index === self.findIndex((t) => t.value === item.value)
            );
          //the following block is converting the states names into the UI format, not a clean fix alternate method needs to be found
          if (fieldCode === "003m") {
            let formatedStatesArray = historyPhrasesForSelectedField.map(
              (eachState: string) => {
                return states.find(
                  (formatedState) =>
                    formatedState.abbr === eachState ||
                    formatedState.name === eachState
                );
              }
            );
            historyPhrasesForSelectedField = formatedStatesArray
              .filter((e: { abbr: string; name: string }) => e !== undefined)
              .map(
                (e: { abbr: string; name: string }) => `${e.name} (${e.abbr})`
              );
            historyPhrasesForSelectedField = Array.from(
              new Set(historyPhrasesForSelectedField)
            );
          }
          let formattedPhrases = historyPhrasesForSelectedField.map(
            (eachPhrase: any, index: Number) => {
              return { text: eachPhrase.value, isSelected: false, index, timeStamp:eachPhrase.timestamp };
            }
          );
          if (phrasesFromDb?.[fieldCode]) {
            if (
              phrasesFromDb?.[fieldCode][0].has.length ===
              formattedPhrases.length
            ) {
              dispatch(
                setSelectedAllFieldsArray({ activeFieldCode: fieldCode })
              );
            }
          }
          dispatch(
            setHistoryListForActiveFieldr({
              formattedPhrases,
              fieldCode,
              phrasesFromDb,
            })
          );
        });
      });
    }
  }, [phrasesFromDb,reRun]);

  useEffect(() => {
    if (errorMessage !== "") {
      setTimeout(() => {
        dispatch(setFilterErrorMessage(""));
      }, 2000);
    }
  }, [errorMessage]);

  const selectFieldToFilter = (fieldCode: string) => {
    setActiveFieldCode(fieldCode);
  };

  const toggleSelect = (index: any, key: string) => {
    setChangesMade(true);
    setIsSettingsSaved(false);
    dispatch(toggleCheckForField({ key, index }));
  };

  const handlesaveSettings = () => {
    let newFilterChoices: any[] = selectedFilterChoices.map(
      (eachFilterChoice: FilterFieldChoiceEntity) => {
        if (eachFilterChoice?.selectedFields) {
          return {
            fieldCode: eachFilterChoice?.fieldCode,
            has: eachFilterChoice?.selectedFields.map((each) => {
              return {
                text:
                  eachFilterChoice?.fieldCode === "003m"
                    ? each.text.split("(")[0].trim()
                    : each.text, // Converting State names from UI format to backend format, not a clean fix alternate method needs to be found
                action: each?.action || "UPDATE",
                ...(each.externalId && { externalId: each.externalId }),
              };
            }),
            hasNot: [],
          };
        }
      }
    );
    const params = {
      fieldCode: activeFieldCode,
      filterId: selectedTabFilter?.id,
      filterChoices: newFilterChoices,
      limitSearchLatest: false,
    };
    dispatch(bulkSaveFilterChoices(params)).then((res) => {
      dispatch(
        fetchUserClientsDocuments({
          clientIds: clients.map((client) => client.id),
          userId: userId.toString(),
        })
      ).then((res) => {
        if (res) {
          setChangesApplied(!changesApplied);
          setIsSettingsSaved(true);
          setNewPhrase("");
        }
      });
    });
  };

  const removeFieldOrSelectedFields = (type: string, sfieldCode: string) => {
    setChangesMade(true);
    setIsSettingsSaved(false);
    if (type === "inidividual") {
      const fieldTobeRemoved = selectedFilterChoices.find(
        ({ fieldCode }) => fieldCode === sfieldCode
      );
      if (fieldTobeRemoved?.historyList && fieldTobeRemoved?.selectedFields) {
        let uncheckedHistroyList = fieldTobeRemoved?.historyList.map((each) => {
          return { ...each, isSelected: false };
        });
        let updatedSelectedList = fieldTobeRemoved?.selectedFields
          .filter((each) => each.externalId)
          .map((each) => {
            return { ...each, isSelected: false, action: "DELETE" };
          });

        dispatch(
          clearSelectedFields({
            sfieldCode,
            uncheckedHistroyList,
            updatedSelectedList,
          })
        );
      }
    } else {
      dispatch(clearAllSelections({}));
    }
  };

  const addTextPhraseToField = () => {
    if (phrase.length !== 0) {
      let trimmedPhrase = phrase.trim();
      setChangesMade(true);
      setIsSettingsSaved(false);
      dispatch(
        addPhraseToSelection({ phrase: trimmedPhrase, activeFieldCode })
      );
      setNewPhrase("");
      return;
    }
    if (editedField.length !== 0) {
      setChangesMade(true);
      setIsSettingsSaved(false);
      dispatch(addPhraseToSelection({ phrase: editedField, activeFieldCode }));
      setEditedField("");
      return;
    }
    dispatch(setFilterErrorMessage("Phrase can not be an empty string"));
  };

  // const actionHandle = () => {};
  const cancelHandle = () => {
    dispatch(setFilterChoiceToBeEdited(-1));
    dispatch(setFilterDialogState(""));
    dispatch(setSelectedTabFilterInfo({}));
  };

  const toggleHistoryListselection = (type: string) => {
    if (type === "selectAll") {
      dispatch(setSelectedAllFieldsArray({ activeFieldCode }));
      removeFieldOrSelectedFields("inidividual", activeFieldCode);
      selectedFilterChoices
        ?.find(({ fieldCode }) => fieldCode === activeFieldCode)
        ?.historyList?.forEach((each) => {
          toggleSelect(each.index, activeFieldCode);
        });
    } else {
      removeFieldOrSelectedFields("inidividual", activeFieldCode);
      dispatch(setUnSelectedAllFieldsArray({ activeFieldCode }));
    }
  };

  const toggleSortType = (type: string) => {
    if (type === "alphabetic") {
      setSortType("alphabetic");
      setRerun(!reRun)
    } else {
      dispatch(sortFilterChoicesv2({sfieldCode:activeFieldCode,sortType:type}))
      setSortType("rco");
    }
  };

  return (
    <div className="tab-filter-container">
      <div className="tf-header-container">
        <div className="tf-header-text-container">
          <span className="tf-filter-name">{tabFilterName}</span>
          &nbsp;&nbsp;
          <span>Tab Filter</span>
        </div>
      </div>
      <div className="tf-body-container">
        <div className="tf-fields-column-container">
          <div className="tf-field-column-header">
            <p className="tf-fields-column-header">
              FIELDS (
              <span className="tf-fields-column-header-orange">AND</span>)
            </p>
          </div>
          <div className="tf-field-column-field-container">
            {tabFilterFieldList?.map(({ name, fieldCode }) => (
              <p key={`${name}+${baseId}`} 
                onClick={() => selectFieldToFilter(fieldCode)} 
                className={`${activeFieldCode === fieldCode && "selected"}`}>
                {name}
              </p>
            ))}
          </div>
          <hr className={activeFieldCode === "003m" ? "hr" : "hr2"} />
        </div>
        <div className="tf-history-column-container">
          <div className="tf-history-column-header">
            <p className="tf-history-column-header">
              HISTORY (
              <span className="tf-history-column-header-orange">OR</span>)
            </p>
          </div>
          <div className="tf-history-column-subheader">
            {selectedFieldsArray &&
            selectedFieldsArray?.length > 0 &&
            selectedFieldsArray?.findIndex(
              (value) => value === activeFieldCode
            ) > -1 ? (
              <button
                className="active"
                onClick={() => toggleHistoryListselection("deSelect")}
              >
                De select
              </button>
            ) : (
              <button
                className="tf-history-column-subheader-p"
                onClick={() => toggleHistoryListselection("selectAll")}
              >
                Select all
              </button>
            )}
            <div className="tf-history-column-subheader-wrapper">
              <button
                className={`${
                  sortType !== "alphabetic"
                    ? "tf-history-column-subheader-p"
                    : "active"
                }`}
                onClick={() => {
                  toggleSortType("alphabetic");
                }}
              >
                Alphabetical
              </button>
              <button
                className={`${
                  sortType !== "rco"
                    ? "tf-history-column-subheader-p"
                    : "active"
                }`}
                onClick={() => {
                  toggleSortType("rco");
                }}
              >
                Most Recent
              </button>
            </div>
          </div>
          <div className="tf-history-column-options-container-shadow">
            {(
              selectedFilterChoices?.find(
                ({ fieldCode }) => fieldCode === activeFieldCode
              )?.historyList ?? []
            ).length === 0 ? (
              <div className="tf-history-column-options-container">
                <div className="tf-history-column-options-container-no-data-div">
                  <p>No Data Available</p>
                </div>
              </div>
            ) : (
              <div className="tf-history-column-options-container">
                {selectedFilterChoices
                  ?.find(({ fieldCode }) => fieldCode === activeFieldCode)
                  ?.historyList?.map(({ text, isSelected }, index) => (
                    <div key={`${text}+${baseId}`} className="tf-history-options-item">
                      {showEditInput && indexOfCurrentItem === index ? (
                        <div className="tf-history-options-item-input-wrapper">
                          <input
                            type="text"
                            className="tf-history-options-item-custom-input"
                            value={editedField}
                            onChange={(e) => {
                              setEditedField(e.target.value);
                            }}
                          />
                          <div className="cutom-input-actions-wrapper">
                            <img
                              src={tick}
                              alt="tick-svg"
                              onClick={() => {
                                setShowEditInput(false);
                                addTextPhraseToField();
                              }}
                            />
                            <img
                              src={customInputcross}
                              alt="cross-svg"
                              onClick={() => {
                                setEditedField("");
                                setShowEditInput(false);
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <>
                          <input
                            type="checkbox"
                            className="tf-history-checkbox"
                            checked={isSelected}
                            onChange={() =>
                              toggleSelect(index, activeFieldCode)
                            }
                          />
                          <p
                            onClick={() => toggleSelect(index, activeFieldCode)}
                          >
                            {text}
                          </p>
                          {activeFieldCode !== "003m" && (
                            <div className="tf-history-options-item-action-container">
                              <img
                                src={duplicate}
                                alt="duplicate-svg"
                                onClick={() => {
                                  setNewPhrase(text);
                                }}
                              />
                              {/*<img
                              src={edit}
                              alt="edit-svg"
                              onClick={() => {
                                setEditedField(text);
                                setShowEditInput(true);
                                setCurrentItemIndex(index);
                              }}
                            />*/}
                              {/* <img
                              src={trashbin}
                              alt="trashbin-svg"
                              // onClick={actionHandle}
                            />*/}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  ))}
              </div>
            )}
          </div>
          {activeFieldCode !== "003m" && (
            <>
              <div className="tf-history-column-custom-text-container">
                <input
                  className="input"
                  onChange={(e) => setNewPhrase(e.target.value)}
                  value={phrase}
                  type="text"
                  placeholder={`Enter Exact ${
                    tabFilterFieldList?.find(
                      ({ fieldCode }) => fieldCode === activeFieldCode
                    )?.name
                  }`}
                ></input>
                <button className="apply-button" onClick={addTextPhraseToField}>
                  Add
                </button>
              </div>
              <p className="error-message">{errorMessage}</p>
            </>
          )}
        </div>
        <div className="tf-selection-container">
          <div className="tf-selection-header-container">
            <div className="tf-selection-header">
              <p className="tf-selection-header-text">FILTER SELECTIONS</p>
              <button
                type="button"
                onClick={() => {
                  removeFieldOrSelectedFields("all", "null");
                  dispatch(setUnSelectedAllFieldsArray({ activeFieldCode: 0 }));
                }}
              >
                Clear All
              </button>
            </div>
          </div>
          <div className="tf-selection-selected-fields-container">
            {selectedFilterChoices.map(
              ({ fieldName, selectedFields, fieldCode }) =>
                selectedFields &&
                selectedFields.filter((each) => each.isSelected).length > 0 && (
                  <div key={`${fieldName}+${baseId}`} className="tf-selection-selected-field">
                    <div className="tf-selection-field-header">
                      <p className="tf-selection-header-text">{fieldName}</p>
                      <button
                        onClick={() => {
                          removeFieldOrSelectedFields("inidividual", fieldCode);
                          dispatch(
                            setUnSelectedAllFieldsArray({ activeFieldCode })
                          );
                        }}
                        className="tf-selection-header-remove-button"
                      >
                        {/* <img src={cross} alt="cross-svg" /> */}
                        Clear
                      </button>
                    </div>
                    {fieldCode &&
                      selectedFields?.length > 0 &&
                      selectedFields?.map(
                        ({ text, index, isSelected }) =>
                          isSelected && (
                            <div className="tf-selection-field-item">
                              <p className="tf-selection-item-header-text">
                                {text}
                              </p>
                              <button
                                onClick={() => toggleSelect(index, fieldCode)}
                                className="tf-selection-header-remove-button"
                              >
                                <img src={cross} alt="cross-svg" />
                              </button>
                            </div>
                          )
                      )}
                  </div>
                )
            )}
          </div>
          <div className="tf-selection-button-container">
            {changesMade && !isSettingsSaved && (
              <button className="apply-button" onClick={handlesaveSettings}>
                Apply
              </button>
            )}
            <button onClick={cancelHandle}>
              {!changesMade && !isSettingsSaved
                ? "Close"
                : changesMade && isSettingsSaved
                ? "Close"
                : "Cancel"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TabFilter;
